import { createFileRoute, Outlet } from "@tanstack/react-router";
import { MarketplaceTopBar } from "@/components/marketplace/MarketplaceTopBar";

export const Route = createFileRoute("/(public)/trouver-un-chef")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <section className="relative">
      <MarketplaceTopBar />
      <Outlet />
    </section>
  );
}
